import { render } from "./TheAdminProfessionalShow.vue?vue&type=template&id=07d87c91&scoped=true&ts=true"
import script from "./TheAdminProfessionalShow.vue?vue&type=script&lang=ts"
export * from "./TheAdminProfessionalShow.vue?vue&type=script&lang=ts"

import "./TheAdminProfessionalShow.vue?vue&type=style&index=0&id=07d87c91&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d87c91"]])

export default __exports__